/* eslint-disable react/prop-types */
import React from 'react';
import { rampGradient } from './chartPalette';
import styles from './FunnelBars.less';

/**
 * FunnelBars —— 横向漏斗条（带相邻层级转化率）
 * ------------------------------------------------------------------
 * 对齐商家端「会员增长情况」里那条 新增会员 → 完成首课 → 完成次课 的
 * 横向漏斗：左侧层级名，中间蓝色渐变条（条内白字写数值），右侧方括号
 * 标注**相对上一级**的转化率。
 *
 * 之前这里做成「阶段名 + 一条灰色进度条 + 右侧百分比」，丢掉了方括号的
 * 相邻语义，也丢了条内数值，看着不像漏斗。
 *
 * @param data      [{ label, value, unit?, tip? }]，按层级从上到下
 * @param max       条长基准，默认取 data 里的最大值
 * @param showRate  是否显示相邻层级转化率，默认 true
 * @param onClick   回调：入参为 item 与 index
 * @param renderRate 每行右侧的自定义内容：入参 item index prevItem，返回 ReactNode。
 *                  会员转化漏斗要把百分比圆环放在**对应层级**的行尾（图4 反馈：
 *                  原来堆在漏斗下方一排，读不出对应关系）。
 */
const FunnelBars = (props) => {
  const { data = [], max, showRate = true, onClick, renderRate } = props;
  if (!data.length) return null;

  const maxValue =
    max || Math.max(...data.map((d) => Number(d.value) || 0)) || 1;

  return (
    <div className={styles.funnel}>
      {data.map((d, i) => {
        const prev = i > 0 ? data[i - 1] : null;
        const rate =
          prev && Number(prev.value)
            ? `${((Number(d.value) / Number(prev.value)) * 100).toFixed(1)}%`
            : null;
        const width = Math.max(6, ((Number(d.value) || 0) / maxValue) * 100);

        return (
          <div
            key={d.label || i}
            className={`${styles.row} ${onClick ? styles.clickable : ''}`}
            onClick={onClick ? () => onClick(d, i) : undefined}
          >
            <span className={styles.label} title={d.tip}>
              {d.label}
            </span>

            <span className={styles.track}>
              <span
                className={styles.bar}
                style={{
                  width: `${width}%`,
                  /* 层级越往下越深；色值统一取自 chartPalette，
                     不再在组件里各写各的蓝 */
                  background: rampGradient(i),
                }}
              >
                <span className={styles.barText}>
                  {d.value ?? '-'}
                  {d.unit}
                </span>
              </span>
            </span>

            <span className={styles.rateCell}>
              {renderRate ? (
                renderRate(d, i, prev)
              ) : showRate && rate ? (
                <>
                  <i className={styles.bracket} />
                  <span className={styles.rate}>{rate}</span>
                </>
              ) : null}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default FunnelBars;
